import React, { ComponentPropsWithoutRef } from "react";

interface Props {
  href?: string;
  className?: string;
  onClick?: ComponentPropsWithoutRef<"a">["onClick"];
  children?: React.ReactNode;
}

const IntelligenceLink = ({ href, className, onClick, children }: Props) => (
  <a href={href} className={className} target="_blank" rel="noopener noreferrer" onClick={onClick}>
    {children}
  </a>
);

export default IntelligenceLink;
